var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}]},_vm._l((_vm.activities),function(activity){return _c('activity-card',{key:activity.id,attrs:{"id":activity.id,"activity":activity}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }